module.exports = __webpack_public_path__ + "img/did-you-know.369fb3c5.svg";